"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_gtm_module_1 = __importDefault(require("react-gtm-module"));
var GoogleTagManager = /** @class */ (function () {
    function GoogleTagManager(gtmId) {
        if (gtmId === void 0) { gtmId = ""; }
        this.gtmId = gtmId;
    }
    GoogleTagManager.prototype.build = function () {
        var tagManagerArgs = {
            gtmId: this.gtmId,
        };
        react_gtm_module_1.default.initialize(tagManagerArgs);
    };
    GoogleTagManager.prototype.eventData = function (data) {
        var tagManagerArgs = {
            gtmId: this.gtmId,
            dataLayer: __assign({}, data),
        };
        react_gtm_module_1.default.initialize(tagManagerArgs);
    };
    GoogleTagManager.prototype.isEnabled = function () {
        return !!this.gtmId;
    };
    /*
      Adding methods below just
      for backwards compatibility
      TODO: remove them after imlementation
    */
    GoogleTagManager.prototype.event = function (_action, _category) { };
    GoogleTagManager.prototype.dimensionEvent = function (_action, _category, _label, _value) { };
    GoogleTagManager.prototype.customEvent = function (_name, _info) { };
    GoogleTagManager.prototype.pageView = function (_path) { };
    GoogleTagManager.prototype.trace = function (_message) { };
    return GoogleTagManager;
}());
exports.default = GoogleTagManager;
